<template>
  <div class="paySuccessShores" v-if="allShorexList && allShorexList.length>0">
    <div class="shores-tabHeader">
      <div class="tabHeader-item" :class="{'active':shoresTabActive===index}"
           v-for="(item, index) in allShorexList"
           :key="index"
           @click="onChangeShoreTab(index,item)">
          <span v-if="item.shorexType===2">{{ item.shorexName }}</span>
      </div>
    </div>
    <div class="confirm-btn" @click="confirmUpdate(allShorexList,shoresTabActive)">
        <p>确认提交</p>
        <p v-show="shorexType===2">费用在登轮后自动从房卡扣除</p>
    </div>
    <div class="shores-tabContent">
      <div class="tabContent-title">
        <div class="title-name" v-if="shoreActiveData.shorexType===2"><span></span>{{ shoreActiveData.shorexName }}</div>
        <SellOutTip v-if="shoreActiveData.showLowStock || shoreActiveData.outOfStock" :outOfStock="shoreActiveData.outOfStock" :showLowStock="shoreActiveData.showLowStock" />
      </div>
      <div class="tabContent" v-for="(item, idx) in shoreActiveData.shorexTours" :key="idx">
        <div class="tabContent-site">
          <img src="https://resource.rcclchina.com.cn/paySuccess/site-icon.png" alt="">
          {{item.shorexName}}
        </div>
        <div class="title-price-new" v-if="shoreActiveData.price>0">价格：<span>${{shoreActiveData.price}}/每人</span></div>
        <div class="tabContent-main">
          {{item.shorexBrief}}
        </div>
        <div class="tabContent-site">
          <img src="https://resource.rcclchina.com.cn/paySuccess/time-icon.png" alt="">
          时长：<span style="color: #FCC300">{{item.duration}}</span>
        </div>
        <div class="tabContent-main">
          <div class="tabContent-img">
            <ShorexSwiper :banner-list="item.bannerList"></ShorexSwiper>
          </div>
          <div class="tabContent-text" v-html="item.shorexDescription"></div>
          <div class="tabContent-text" v-html="item.introWarningText"></div>
          <div class="notice">
            <p>注：</p>
            <div>
              （1）<p>目的地的产品及行程仅供参考,实际行程以具体航次和地接社安排为准</p>
            </div>
            <div>
              （2）<p>目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</p>
            </div>
            <div>
              （3）<p>皇家行前订目前只提供全程观光套餐，您可于登船后购买单一港口观光产品，全程套餐与单一港口观光产品均数量有限，先到先得。</p>
            </div>
            <div>
              （4）<p>如需取消已预订的精品游订单，请联系皇家行前订客服协助操作。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reserve-notice">
      <div class="reserve-notice-title">预订须知</div>
      <ul>
        <li>(1) 精品游行程的最低成团人数为38人，如未能达到最低成团人数，将于开航日前两周通知乘客；</li>
        <li>(2) 本网站提供的岸上观光产品的行程与时长等信息仅供参考，景点游览次序、停留时间等会因不可抗力、当地客流量和交通等原因有所调整，具体以地接社实际接待为准；</li>
        <li>(3) 岸上观光产品的具体集合时间、地点以及线路安排等信息将通过信件的方式直接放置于乘客的舱房内，乘客需于登船后自行查看舱房内的信件通知，及时获得有关信息，并按照规定的时间和地点集合。通期不予等候、退款或更换，请乘客务必按时出席。</li>
        <li>(4) 目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</li>
        <li>(5) 关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。</li>
      </ul>
    </div>
    <div class="confirm-btn" @click="confirmUpdate(allShorexList,shoresTabActive)">
      <p>确认提交</p>
      <p v-show="shorexType===2">费用在登轮后自动从房卡扣除</p>
    </div>
    <div class="shoresDetailModel" id="shoppingCartModal" v-if="isShowDetail">
      <div class="shoresDetailModel-bg" @click="isShowDetail=!isShowDetail"></div>
      <div class="shoresDetailModel-container">
        <div style="border-bottom: 1px solid #f7f7f7;margin-bottom: 15px">
          <div class="shoresDetailModel-title">
            确定为以下预订选择岸上观光行程
          </div>
          <div class="select-btn">请选择订单<img src="https://resource.rcclchina.com.cn/paySuccess/bottom-arrows.png" alt=""></div>
          <div class="select-order">
            <div class="order-item" v-for="(x,d) in shoreActiveData.shorexOrderInfos" :key="d"
                 @click="onChangeOrder(shoreActiveData,x,)">
              <span class="checkBox-btn" :class="{'active':isInTempBookings(x.bookingId,shoreActiveData.id) }">
                <img src="https://resource.rcclchina.com.cn/paySuccess/check.png" alt="">
              </span>
              <div class="order-info">
                <span style="white-space: nowrap">订单号：{{ x.bookingId }}</span> <span
                  class="order-pis">乘客信息：{{ getPassengerName(x.bookingGuests) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="shoresDetailModel-main">
          <div class="main-name" v-if="shorexType===2"><span></span>{{orderInfoList.shorexName}}</div>
          <div class="main-shoreOder">订单号：{{orderInfoList.shorexOrderInfos[0].bookingId}} <span>联系人：{{orderInfoList.shorexOrderInfos[0].contact}}</span></div>
          <div class="main-passenger">
            <div class="main-passenger-item" v-for="(x,idx) in orderInfoList.shorexOrderInfos[0].bookingGuests" :key="idx">
              <div>乘客{{ transitionChinese(idx+1) }}</div>
              <div v-if="x.chineseLastName || x.chineseFirstName">{{ x.chineseLastName || ''}}{{x.chineseFirstName || ''}}</div>
              <div v-else>{{ x.pinYinLastName }}{{x.pinYinFirstName}}</div>
            </div>
          </div>
        </div>
        <div class="shoresDetailModel-closed js-closedBtn" @click="isShowDetail=!isShowDetail"><span class="">X</span></div>
      </div>
      <div class="order-detail-btn">
        <div class="goBack-btn" @click="goBack">返回修改</div>
        <div class="submit-btn" @click="submit">确认提交</div>
      </div>
    </div>
    <div class="hasShoresTips" v-if="isHasShores">
      <div class="hasShoresTips-container">
        <div class="con-title">温馨提示</div>
        <div class="con-text">尊敬的客人，皇家官方为您提供多种<br>岸上观光行程如下，您可自主进行选订。<br>如不选订任何行程则视为自助游，您需自行安排<br>目的地游览行程。</div>
        <div class="con-btn" @click="isHasShores=false">我知道了</div>
      </div>
    </div>
  </div>
  <div v-else class="noShorex">
    <div class="noShorex-img">
      <img src="https://resource.rcclchina.com.cn/cruiseDetail/shorexCompTour/noShorex.png" alt="">
    </div>
    <div class="noShorex-text">
      <img src="https://resource.rcclchina.com.cn/paySuccess/hint-icon.png" alt="">
      <div>{{payShorexOnlyStr}}选订开放后，我们会在第一时间通知您。您也可以密切关注皇家加勒比官方网站， 后续可至<span @click="goToPcp" style="color: #006AB6;">>>皇家行前订</span>进行预订</div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import {formatYYYYMMDD, gioTracking, isWechatBrowser} from "@/utilities/tools";
import ShorexSwiper from "@/components/Booking/ShorexSwiper.vue";
import SellOutTip from "@/components/SellOutTip.vue";

export default {
  components: {
    ShorexSwiper,
    SellOutTip
  },
  props:{
    shoreData:{
      type:Object,
      default:()=>{
        return {}
      }
    },
    allShorexList:{
      type:Array,
      default:()=>{
        return []
      }
    },
    payShorexOnlyStr:{
      type:String,
      default:''
    }
  },
  data(){
    return {
      shoresTabList:{},
      shoreActiveData:[],
      shoresTabActive:0,  //选中tab索引
      orderId:'',
      isShowDetail:false,
      passengerInfo:[],
      selectShore:[],
      tempBookings:[],
      orderInfoList:{},
      allShoreTabList:null,
      shorexType:0,
      isHasShores:false,
      
      isShowSubBtn:true
    }
  },
  methods:{
    // 切换tab
    onChangeShoreTab(idx,item){
      console.log(this.allShorexList,idx)
      this.shoresTabActive = idx
      this.shoreActiveData =  this.allShorexList[idx]
      this.shorexType = this.shoreActiveData?.shorexType
      let time = formatYYYYMMDD(item.sailDate)
      let gioInfo = 'shorexUpsellSaildate'+time+item.shorexName
      gioTracking('track','evt_ButtonClicked',{'btnTypes':gioInfo})

      if(item.outOfStock == true){
        this.isShowSubBtn = false
      }else{
        this.isShowSubBtn = true
      }
    },
    // 选择订单
    onChangeOrder(item,x){
      if (this.isInTempBookings(x.bookingId,item.id)) {
        this.tempBookings = this.tempBookings.filter(r=> r.bookingId !== x.bookingId )
      } else {
        let isInTemp = this.tempBookings.some(r => r.id !== item.id);
        if(isInTemp){
          this.$alert.show('该订单已选择其他岸上观光行程，是否重新选择？', {
            confirmCallBack: () => {
              this.tempBookings = this.tempBookings.filter(r =>r.bookingId !== x.bookingId);
              x.id = item.id
              x.shorexName = item.shorexName
              x.sailDate = item.sailDate
              this.tempBookings.push(x)
            }
          });
        }else{
          x.id = item.id
          x.shorexName = item.shorexName
          x.sailDate = item.sailDate
          this.tempBookings.push(x)
        }
      }
      // this.orderInfoList = this.tempBookings
    },
    isInTempBookings(bookingRecordId,id) {
      return this.tempBookings.some(r=> r.id===id && r.bookingId === bookingRecordId)
    },
    // 点击确认升级
    confirmUpdate(arr,x){
      if(this.isShowSubBtn == false){
        this.$alert.show('该岸上观光已售罄')
        return
      }
      let time = formatYYYYMMDD(arr[0].sailDate)
      let gioInfo = 'shorexUpsellConfirmSaildate'+time+arr[0].shorexName
      gioTracking('track','evt_ButtonClicked',{'btnTypes':gioInfo})
      this.isShowDetail = true
      this.orderInfoList = arr[x]
      console.log(this.orderInfoList)
    },
    // 获取订单乘客姓名然后拼接
    getPassengerName(list){
      let allName = ''
      if(list.length > 0){
        list.forEach(item=>{
          let name = ''
          name = item.chineseLastName + item.chineseFirstName
          allName += name + ' | '
        })
        return allName.substring(0, allName.length - 3)
      }
    },
    transitionChinese(str){
      switch (str){
        case 1:
          return '一'
        case 2:
          return '二'
        case 3:
          return '三'
        case 4:
          return '四'
        case 5:
          return '五'
      }
    },
    goBack(){
      this.isShowDetail = false
    },
    async submit() {
      // console.log('tempBookings',this.tempBookings)
      let source = 'mobile'
      // 判断是否为微信浏览器
      if(isWechatBrowser){
        source = 'weixin'
      }
      this.selectShore = this.tempBookings.map(item=>{
        return {
          encBookingId: item.encBookingId,
          shorexId: item.id,
          source:source
        }
      })
      if(this.selectShore && this.selectShore.length === 0) {
        this.$alert.show('请至少选择一条订单')
        return
      }
      const requestData = {
        viewModel: this.selectShore
      }
      this.$loading.show()
      const {success, data, errMsg} = await api.booking.selectShorexV2(requestData)
      this.$loading.hide()
      console.log(this.selectShore)
      if (success) {
        let tipsText = '升级成功'
        if(this.shorexType===1){
          tipsText = '提交成功'
        }
        this.$alert.show(tipsText,{
          confirmCallBack: ()=> {
            // window.open(process.env.VUE_APP_BASE_URL+'/Rccl.Booking/Booking/PaySuccessBack')
            this.$router.push('/Rccl.Booking/Booking/PaySuccessBack?isShowPopup='+data.isShowPopup)
            this.tempBookings = []
            this.shoresTabActive = 0
            this.isShowDetail = false
          }
        })
      }else{
        if (errMsg && errMsg.length > 0) {
            this.$alert.show(errMsg)
        }
      }
      console.error(errMsg)
    },
    isImg(url) {
      //获取最后一个.的位置
      const index = url.lastIndexOf(".");
      //获取后缀
      const ext = url.substring(index + 1); // wxs不支持substr
      // 进行判断
      return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1
    },
    async goToPcp () {
      const { data } = await api.user.getPcpToken()
      let token = ""
      if (data && data.length > 0) {
        token = data
      }
      const url = `${process.env.VUE_APP_PCP_URL}/Rccl.Pcp/product/pcpShorex?token=${token}`
      location.href = url
    }
  },
  watch:{
    shoreData: {
      handler(newVal) {
        this.shoresTabList = newVal
        this.shoreActiveData =  this.allShorexList[this.shoresTabActive]
        this.shorexType = this.shoreActiveData?.shorexType
      },
      immediate: true
    },
    allShorexList: {
      handler(newVal){
        this.isHasShores = newVal && newVal.length>0
      },
      immediate: true
    }
  },
  computed:{}
}
</script>
<style scoped lang="less">
.paySuccessShores{
  width: 100%;
  padding: 0 12px;
  & .shores-tabHeader{
    width: 100%;
    height: 28px;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    align-items: center;
    gap: 6px;
    & .tabHeader-item{
      padding: 6px 12px;
      background: #EEEEEE;
      color: #282828;
      white-space: nowrap;
      font-size: 11px;
      border-radius: 5px;
    }
    & .tabHeader-item.active{
      background: #FCC300;
      color: #fff;
    }
  }
  & .shores-tabContent{
    background-color: #F4FBFF;
    padding: 20px 14px 16px;
    border-radius: 4px;
    margin-top: 14px;
    & .tabContent-title{
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      & .title-name{
        font-weight: bold;
        color: #282828;
        display: flex;
        align-items: center;
        gap: 11px;
        & span{
          display: inline-block;
          width: 3px;
          height: 14px;
          background: #FCC300;
        }
      }
      
    }
    & .tabContent{
      margin-top: 9px;
      & .tabContent-site{
        font-size: 12px;
        color: #006AB6;
        font-weight: 600;
        margin: 7px 0;
        & img{
          width: 10px;
          height: 11px;
        }
      }
      & .tabContent-main{
        color: #282828;
        font-size: 12px;
        & .tabContent-img{
          width: 100%;
          margin: 10px 0 14px;
          border-radius: 4px;
          overflow: hidden;
          & img{
            width: 100%;
            height: 100%;
          }
        }
        & .tabContent-text{
          font-weight: 400;
        }
        & .tabContent-text /deep/ p {
          margin: 0;
        }
        & .notice{
          font-size: 9px;
          color: #282828;
          margin: 14px 0 8px;
          & div{
            display: flex;
            align-items: baseline;
            & p{
              margin: 3px 0;
            }
          }
        }
      }
    }
  }
  & .reserve-notice{
    padding: 9px 20px 7px;
    background-color: #F7F7F7;
    margin-top: 11px;
    border-radius: 4px;
    & .reserve-notice-title{
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      padding-bottom: 8px;
      text-align: center;
      border-bottom: 1px solid #E3E3E3;
      margin-bottom: 13px;
    }
    & ul{
      font-weight: 400;
      font-size: 10px;
      color: #282828;
      height: 90px;
      overflow: auto;
      background-color: #F7F7F7;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #F7F7F7;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #FDCB0A;
      }
      & li{
        margin-bottom: 8px;
      }
    }
  }
  & .confirm-btn{
    width: 100%;
    height: 42px;
    text-align: center;
    padding: 0 15px;
    border-radius: 22px;
    margin-top: 20px;
    background: linear-gradient( 225deg, #FFDB17 0%, #FCBF00 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    & p:first-child{
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      margin: 0;
    }
    & p:last-child{
      font-weight: 400;
      font-size: 9px;
      color: #000000;
      margin: 0;
    }
  }
}
.shoresDetailModel {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  .shoresDetailModel-bg {
    background-color: rgba(0,0,0,.4);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 94px;
  }
  .shoresDetailModel-container {
    background-color: #fff;
    border-top: 5px solid #FEBC10;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 22px 20px 54px;
    & .shoresDetailModel-title{
      font-weight: 600;
      font-size: 16px;
      color: #000000;
      padding-bottom: 9px;
      margin-bottom: 5px;
    }
    & .shoresDetailModel-main{
      & .main-name{
        font-weight: 600;
        font-size: 14px;
        color: #4A4A4A;
        display: flex;
        align-items: center;
        gap: 9px;
        margin-bottom: 6px;
        & span{
          display: inline-block;
          width: 3px;
          height: 14px;
          background: #FCC300;
        }
      }
      & .main-shoreOder{
        font-weight: 600;
        font-size: 12px;
        color: #9B9B9B;
        margin-bottom: 6px;
        & span{
          margin-left: 26px;
        }
      }
      & .main-passenger{
        background-color: #F7F7F7;
        border: 5px;
        margin-bottom: 24px;
        padding: 0 18px 12px;
        border-radius: 5px;
        & .main-passenger-item{
          font-weight: 600;
          font-size: 12px;
          color: #4A4A4A;
          border-bottom: 1px solid #E2E2E2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 0;
        }
      }
    }
    .shoresDetailModel-closed {
      width: 38px;
      text-align: center;
      height: 34px;
      line-height: 34px;
      position: absolute;
      top: -4px;
      right: -4px;
      background: #FEBC10;
      border-bottom-left-radius: 8px;
      -webkit-border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      -webkit-border-bottom-right-radius: 8px;
      > span {
        display: inline-block;
        color: #fff;
        font-size: 16px;
        -webkit-transform: scale(1.5,1.3);
        -moz-transform: scale(1.5,1.3);
        -ms-transform: scale(1.5,1.3);
        -o-transform: scale(1.5,1.3);
        transform: scale(1.5,1.3);
      }
    }
  }
  & .order-detail-btn{
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
    & .goBack-btn{
      width: 50%;
      height: 54px;
      background: #E5E1E1;
      line-height: 54px;
    }
    & .submit-btn{
      width: 50%;
      height: 54px;
      line-height: 54px;
      background: linear-gradient( 127deg, rgba(252,192,1,0.98) 0%, #FFDA17 100%);
    }
  }
}
.noShorex{
  font-weight: 600;
  font-size: 13px;
  color: #282828;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .noShorex-img{
    width: 90px;
    height: 70px;
    img{
      width: 100%;
    }

  }
  .noShorex-text{
    gap: 3px;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 22px 0 20px;
    margin-top: 3px;
    //文字首行缩进
    div{
      &::first-letter{
        margin-left: 22px;
      }
    }

    img{
      width: 15px;
      height: 15px;
      position: absolute;
      top: 2px;
      left: 20px;
    }
  }
}
.select-order{
    width: 100%;
    & .order-item{
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      margin-bottom: 5px;
      & .checkBox-btn{
        width: 16px;
        height: 16px;
        border: 2px solid #D8D8D8;
        background: #FFFFFF;
        border-radius: 4px;
        margin-right: 5px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        & img{
          width: 10px;
          height: 7px;
        }
      }
      & .checkBox-btn.active{
        background-color: #FCC300;
        border: none;
      }
      & .order-info{
        width: calc(100% - 21px);
        display: flex;
        align-items: center;
        & .order-pis{
          margin-left: 10px;
          text-overflow: ellipsis;
          font-size: 9px;
          white-space: nowrap;
          overflow: hidden;
        }
      }

    }
  }
.select-btn {
  width: 100%;
  height: 20px;
  color: #fff;
  background-color: #006AB6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-size: 12px;
  margin-bottom: 15px;
  img{
    width: 8px;
    height: 8px;
  }
}
.hasShoresTips{
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0,0,0,.4);
  top: 0;
  left: 0;
  z-index: 10003;
  .hasShoresTips-container{
    width: 330px;
    height: 250px;
    background-color: #fff;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    box-sizing: border-box;
    color: #282828;
    & .con-title{
      font-size: 18px;
      padding: 23px 13px 18px;
      border-bottom: 1px solid #D8D8D8;
    }
    & .con-text{
      margin-top: 19px;
      font-size: 14px;
      padding: 0 13px;
      line-height: 24px;
    }
    & .con-btn{
      width: 100%;
      height: 40px;
      background-color: #FFDA16;
      text-align: center;
      line-height: 40px;
      margin-top: 30px;
      border-radius: 0 0 8px 8px;
    }
  }
}

 .title-price-new{
        color: #282828;
        margin-bottom: 7px;
        & span{
          font-weight: 800;
          color: #006AB6;
        }
      }
</style>
